/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="reportScheduler.module.ts" />
/// <reference path="reportScheduler.context.ts" />


module Meevo.Plugins.ReportScheduler {

    import Timer = NodeJS.Timer;
    import IReportGeneralInfo = Meevo.Model.IReportGeneral;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import SecurityParts = Meevo.Components.Common.SecurityParts;

    class ReportSchedulerController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$sce',
            '$q',
            'meevo.plugins.reportScheduler.ReportsHelper',
            "$translate",
            "$timeout"
        ];

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected deleteSecurityKey: string;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        public customDisplayNameColumns: any;
        public customColumns: any;
        reportLoadTimeout: Timer;
        params: string;
        reportList: Array<IReportGeneralInfo>;
        reportCategories: Array<IReportCategory>;
        protected promiseLoadReportCat: ng.IPromise<IReportCategory[]>;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $sce: angular.ISCEService,
            protected $q: angular.IQService,
            protected reportsHelper: IReportsHelper,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.customDisplayNameColumns = { header: this.$translate.instant("LABEL_REPORT_NAME"), fieldName: 'displayName', sortDirection: null, width: 20 };

            this.customColumns = [
                { header: this.$translate.instant("LABEL_SCHEDULE_NAME"), fieldName: 'scheduleName', sortDirection: null, width: null, className: "padding-left-15" },
                { header: this.$translate.instant("LABEL_RECIPIENTS"), fieldName: 'recipientsSummary', sortDirection: null, width: null, className: "maint-form-center-align" },
                { header: this.$translate.instant("LABEL_NEXT_SCHEDULED_DELIVERY"), fieldName: 'nextScheduledDelivery', sortDirection: null, width: null },
            ];

            this.reportList = [];
            this.reportCategories = [];
        }

        async applyParams(params) {
            await super.applyParams(params);
            if (this.$timeout) {
                var p = this.$timeout(10).then(() => { return this.delayedApplyParams(this.contextParams.params); });
                if (p) {
                    p.then(() => {
                        let context = (<ReportSchedulerContext>this.context);
                        if (Model.Guard.isSomething(context) && this.contextParams && this.contextParams.params) {
                            if (params.actionState == Model.MaintenanceFormState.Adding && this.contextParams.params.reportId) {
                                context.showMenuType = Meevo.Model.PageStateEnum.Controls;
                            }
                        }
                    });
                }
            }
        }

        delayedApplyParams(params): ng.IPromise<any> {
            if (Model.Guard.isSomething(params)) {
                let context = (<ReportSchedulerContext>this.context);
                if (Model.Guard.isSomething(context)) {
                    return this.navigateToSection(context, params);
                }
            }
            return null;
        }

        navigateToSection(context, params): ng.IPromise<any> {
            let section: any;
            if (params.initialEditSection) {
                section = _.find(context.sections, (s: any) => { return s.displayNameContentKey === params.initialEditSection });
                if (Model.Guard.isSomething(section)) {
                    if (Model.Guard.isSomething(this.selectedItemId)) {
                        context.selectSection(section);
                        context.activate(this.selectedItemId, this.initialEditSection);
                        if (params.actionState) {
                            context.setMode(params.actionState);
                        }
                        else {
                            context.setMode(Model.MaintenanceFormState.Readonly);
                        }
                    }
                    else if (params.actionState == Model.MaintenanceFormState.Adding) {
                        section.createInstance(null);
                        context.headerContent = '';
                        context.activate(null, params.initialEditSection);
                        context.setMode(Model.MaintenanceFormState.Adding);
                        if (params.reportId) {
                            var report = _.findWhere(this.reportList, { id: params.reportId });
                            if (report) {
                                return context.loadReportInputTemplate(report, true);
                            }
                        }
                    }
                }
            }
            return this.$q.resolve();
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            var vm = this;
            vm.busyService.start();
            this.$q.all([
                vm.securityService.checkSection(vm.meevoSecurityKeys.MANAGEMENT_REPORTSCHEDULE_TAB_MAIN),
                this.loadReportCategories()
            ]).then(() => {
                vm.busyService.stop();
                vm.context = new ReportSchedulerContext(
                    vm.appSettings,
                    vm.dataService,
                    vm.modalService,
                    vm.identityService,
                    vm.loggingService,
                    vm.busyService,
                    vm.securityService,
                    vm.trackingService,
                    vm.$scope,
                    vm.$sce,
                    vm.$q,
                    vm.reportsHelper,
                    vm.$translate,
                    vm.$rootScope,
                    vm.reportCategories,
                    vm.reportList
                );
                vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
                vm.context.deactivate = () => {
                    vm.visualState = Model.MaintenanceFormVisualState.Search;
                };
                this.delayedApplyParams(this.contextParams.params);
            }).catch(() => {
                vm.busyService.stop();
            }).finally(() => {
                vm.$timeout(() => {
                    vm.bindHotkeys();
                });
            });
        }

        preSearchCallback(criteria, rootCriteria): void {
            if (this.identityService.inCentralOfficeMode && criteria.location) {
                rootCriteria.asLocationId = criteria.location.id;
            }
            else
                rootCriteria.asLocationId = null;

            if (criteria.showFormSection != 1) {
                criteria.emailAddress = '';
            }

            if (criteria.showFormSection != 2) {
                criteria.phoneNumber = '';
            }

            if (criteria.showFormSection != 3) {
                criteria.employeeCategory = null;
            }

            if (criteria.showFormSection != 4) {
                criteria.employee = null;
            }

            // use data selected from typeahead to set the id
            if (criteria.employee) {
                criteria.employeeId = criteria.employee.id;
            }
            else {
                criteria.employeeId = null;
            }

            // use data selected from typeahead to set the id
            if (criteria.employeeCategory) {
                criteria.employeeCategoryId = criteria.employeeCategory.id;
            }
            else {
                criteria.employeeCategoryId = null;
            }
        }

        /**
         * Load list of report categories
         * @return Promise
         * */
        loadReportCategories(showBusy: boolean = true): ng.IPromise<IReportCategory[]> {
            if (showBusy) {
                this.busyService.start();
            }

            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.reportCategories, {
                criteria: {
                    isContainsReports: true,
                    objectStateEnum: ObjectStateEnum.Active
                }
            })
                .then((result: IReportCategory[]) => this.checkSecurityReport(result))
                .then((result: IReportCategory[]) => {
                    this.reportCategories = result;

                    return this.getAllAvailableReports().then((reportList: Array<IReportGeneralInfo>) => {
                        if (showBusy) {
                            this.busyService.stop();
                        }
                        this.reportList = reportList;
                        var reportDict = _.groupBy(this.reportList, "reportCatId");
                        this.reportCategories = _.filter(this.reportCategories, (category) => !!(reportDict[category.id]));
                        this.reportCategories.forEach((category) => { category.reports = reportDict[category.id]; });
                        return this.reportCategories;
                    });
                });
        }

        /**
         * Check reports by security key
         */
        checkSecurityReport(reports: IReportCategory[]): ng.IPromise<IReportCategory[]> {
            let promises = reports.map((report) => {
                const securityName: string = this.reportsHelper.reportNameToSecurityKey(report.displayName);

                return this.securityService.checkSecurityKey('REPORTS:' + securityName + SecurityParts.KEY_PART_READ)
            });

            return this.$q.all(promises).then(() => {
                let result: IReportCategory[] = [];
                reports.forEach((item) => {
                    const securityName: string = this.reportsHelper.reportNameToSecurityKey(item.displayName);
                    if (this.securityService.hasSecurity('REPORTS:' + securityName + SecurityParts.KEY_PART_READ)) {
                        result.push(item);
                    }
                });

                return result;
            });

        }

        allowReportToBeScheduled = (report: any): boolean => {
            if (report.isScheduled != null) {
                return report.isScheduled;
            }
            else {
                var canBeScheduled = false;

                switch (report.shortCut) {
                    case "AQ020":
                    case "AQ022":
                    case "AQ010":
                    case "AQ225":
                    case "MR080":
                    case "MR085":
                    case "MR200":
                    case "MR145":
                    case "MR110":
                    case "AQ246":
                    case "MES10":
                    case "MES01":

                    case "DB015":
                    case "DB040":
                    case "DE070":
                    case "MR075":
                    case "MR245":
                    case "AQ226":
                    case "MR090":
                    case "MR115":

                    case "CF001":
                    case "MR095":
                    case "MR240":
                    case "DB042":
                    case "CO000":
                    case "MR070":
                    case "AQ065":
                    case "AQ070":
                    case "AQ210":
                    case "AQ230":
                    case "MA200":
                    case "MA050":
                    case "MA060":
                    case "DC041":
                    case "MR118":
                    case "MR129":
                    case "MR129B":
                    case "MR230":
                    case "DR020":
                    case "MR035":
                    case "DE001":
                    case "DE005":
                    case "MR100":
                    case "WI005":
                    case "WI015":
                        canBeScheduled = true;
                        break;
                    // reports with irregular date range parameter (not likely to be an option for scheduler in their current form):
                    // More Info can be found in User Story 8333
                    case "DB050":
                    case "MA075":
                    case "MA225":
                    case "DC042":
                    case "DE045":
                    case "MI025":
                    case "MI210":
                    case "DB050":
                    case "DE040":
                    case "DE044":
                    case "MR130":
                    case "WI010":
                        canBeScheduled = false;
                        break;
                }

                return canBeScheduled;
            }
        }

        getAllAvailableReports(pageNum: number = 0): ng.IPromise<Array<IReportGeneralInfo>> {
            const pageSize: number = 10000;
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.report, { criteria: { objectStateEnum: ObjectStateEnum.Active }, itemsPerPage: pageSize, pageNumber: pageNum })
                .then((result: Array<IReportGeneralInfo>) => {
                    var reports: Array<IReportGeneralInfo> = _.chain(result)
                        .filter(this.allowReportToBeScheduled)
                        .filter((report) => this.securityService.checkCachedSecurityKey(report.securityKey) !== SecurityAccessEnum.Hide)
                        .value();
                    if (result.length >= pageSize) {
                        return this.getAllAvailableReports(pageNum++).then((moreReports: Array<IReportGeneralInfo>) => { return reports.concat(moreReports); });
                    }
                    return reports;
                });
        }

    }

    angular.module('meevo.plugins.reportScheduler')
        .controller('meevo.plugins.reportScheduler.ReportSchedulerController', ReportSchedulerController);
}
